import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { ClassType } from 'types/data/course';
import { padNumber } from 'utils/general';

import { Step, StepLabel, Stepper } from '@mui/material';

import CertificateModal from '@/components/molecules/modals/CertificateModal';
import { ReactComponent as IconPdf } from '@assets/icons/IconPdf.svg';

import { Container, ActionButton } from './styles';

const ClassesList = ({
    classes,
    progress,
    changeClass,
    currentClassNumber,
    maxClassNumber,
    finished,
    finishedCourse,
    courseUser,
    courseTitle
}) => {
    const { user } = useSelector((state) => state.auth);
    const [openCertificateModal, setOpenCertificateModal] = useState(false);

    const handleCertificateModal = () => {
        setOpenCertificateModal(!openCertificateModal);
    };

    const activeStep = () => {
        if (!finished && currentClassNumber === maxClassNumber) {
            return currentClassNumber - 1;
        }

        if (finished && currentClassNumber === maxClassNumber) {
            return currentClassNumber;
        }

        if (currentClassNumber === maxClassNumber) {
            return currentClassNumber;
        }

        return maxClassNumber - !finishedCourse;
    };

    return (
        <Container>
            <Stepper activeStep={activeStep()} orientation="vertical" nonLinear>
                {classes.map((classItem, index) => (
                    <Step
                        key={`${classItem.number === undefined ? 'quiz' : 'lesson'}-${classItem.id ?? index}`}
                        sx={{
                            '& .MuiStepLabel-root .Mui-completed': {
                                color: 'secondary.light' // circle color (COMPLETED)
                            },
                            '& .MuiStepLabel-label.Mui-completed': {
                                color: '#373848', // Just text label (COMPLETED)
                                fontWeight: '500'
                            },
                            '& .MuiStepIcon-root': {
                                fontSize: '20px',
                                width: '20px',
                                height: '20px'
                            }
                        }}
                        completed={classItem.number === undefined ? classItem.asking?.[0]?.asking_user : classItem.class_user?.is_completed}
                        active={index + 1 === currentClassNumber}
                    >
                        {classItem.number === undefined ? (
                            <StepLabel style={{ cursor: 'pointer' }} onClick={() => changeClass(Number(classItem.number))}>
                                <span style={{ fontWeight: currentClassNumber === undefined ? '600' : undefined }}>Avaliação final</span>
                            </StepLabel>
                        ) : (
                            <StepLabel style={{ cursor: 'pointer' }} onClick={() => changeClass(Number(classItem.number))}>
                                {Number(classItem.number) === currentClassNumber ? (
                                    <>
                                        <span style={{ fontWeight: '600' }}>
                                            Aula {padNumber(Number(classItem.number))}: {classItem.title}
                                        </span>
                                    </>
                                ) : (
                                    `Aula ${padNumber(Number(classItem.number))}: ${classItem.title}`
                                )}
                            </StepLabel>
                        )}
                    </Step>
                ))}
            </Stepper>
            {courseUser != null && courseUser.is_completed == 1 && user?.enterprise?.id !== 23 ? (
                <ActionButton
                    disabled={openCertificateModal || progress < 100}
                    startIcon={<IconPdf />}
                    onClick={handleCertificateModal}
                    sx={{ opacity: openCertificateModal ? 0.5 : 1 }}
                >
                    Certificado
                </ActionButton>
            ) : (
                ''
            )}
            {openCertificateModal && (
                <CertificateModal
                    open={openCertificateModal}
                    course={courseUser}
                    handleClose={handleCertificateModal}
                    courseTitle={courseTitle}
                />
            )}
        </Container>
    );
};

ClassesList.propTypes = {
    classes: PropTypes.arrayOf(PropTypes.shape(ClassType)).isRequired,
    changeClass: PropTypes.func.isRequired,
    currentClassNumber: PropTypes.number.isRequired,
    maxClassNumber: PropTypes.number.isRequired,
    finished: PropTypes.bool.isRequired,
    finishedCourse: PropTypes.bool.isRequired
};

export default ClassesList;
